/*--------------------------------------------------------------
# Custom scripts for Maps block
--------------------------------------------------------------*/


if(typeof key !== 'undefined'){
    // Import Google Maps
    (g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})
        ({key: key, v: "weekly"});

    let map;

    async function initMap() {
        const { Map } = await google.maps.importLibrary( 'maps' );
        const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

        // Set the map
        map = new Map(
            document.getElementById( mapContainerId ),{
                center: { lat: lat, lng: lng },
                zoom: zoom,
                disableDefaultUI: disableUi,
                mapId: "map-wrap",
            }
        );

        // Set the info window/rollover
        const infowindow = new google.maps.InfoWindow({
            content: infoHtml,
            ariaLabel: ariaLabel, 
        });

        // Create img element
        const customPin = document.createElement("img");
        customPin.src = pinSrc;
        customPin.alt = 'Green pin icon';
        
        // Set the pin/marker
        const marker = new google.maps.marker.AdvancedMarkerElement({
            position: map.center,
            map,
            content: customPin,
            title: pinTitle,
        });

        // Add 'click' listener and open info window/rollover
        marker.addListener("click", () => {
            infowindow.open({
            anchor: marker,
            map,
            });
        });
        
    }

    initMap();
}